// @flow
import * as React from 'react';
import type { Line } from 'esm-web-pro/containers/pages/network/objects/cable/create/CreateCable';
import { Field, FieldProps } from 'formik';
import TextInput from 'speed-js-react-web/src/components/grommet2/forms/fields/TextInput';
import { FormattedMessage } from 'react-intl';


type Props = {
    line: Line,
    onChange: (providerRef: ?string) => void,
};

const CablePathProviderRef = (props: Props) => {
    const { line: { startNumber }, onChange } = props;

    const key = `${startNumber}-provider-ref`;

    return (
        <Field name={key} key={key}>
            {(field: FieldProps) => (
                <TextInput
                    {...field}
                    field={{
                        ...field.field,
                        onChange: (e) => {
                            onChange(e.target.value);
                            field.field.onChange(e);
                        },
                    }}
                    label={(
                        <FormattedMessage
                            id="cable-path-provider-ref"
                            defaultMessage="Provider ref {startNumber} - {endNumber}"
                            values={{
                                startNumber,
                                endNumber: startNumber + 1,
                            }}
                        />
                    )}
                />
            )}
        </Field>
    );
};

export default CablePathProviderRef;
